import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const Offer = () => {
  return <section className="py-16 md:py-24 px-6 bg-charcoal text-cream text-center" data-id="element-58">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-serif" data-id="element-61">
            Recuperar tu salud mental y ver a tu hijo descansar feliz no debería
            costar una fortuna.
          </h2>
          <p className="text-lg text-cream/80" data-id="element-62">
            Hoy puedes acceder al Método ADORMECER completo por una inversión
            única.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white text-charcoal p-8 md:p-12 rounded-3xl max-w-md mx-auto shadow-2xl" data-id="element-63">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta mb-2" data-id="element-64">
            Precio del Protocolo Completo
          </p>
          <div className="flex justify-center items-start mb-8" data-id="element-65">
            <span className="text-6xl font-serif font-bold" data-id="element-66">6,39</span>
            <span className="text-3xl font-serif mt-1" data-id="element-67">€</span>
          </div>

          <Button className="w-full mb-4" data-id="element-68">
            ¡QUIERO RECUPERAR MI SUEÑO AHORA!
          </Button>

          <p className="text-sm text-charcoal/60" data-id="element-69">
            Acceso inmediato tras la compra. Empieza esta misma noche.
          </p>
        </motion.div>
      </div>
    </section>;
};